/** @format */

import React, { useEffect } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';

import Loading from '../Loading';
import ItemLine from './ItemLine';

function ItemsPicker() {
	const fetchAvailableArticles = useStoreActions((actions) => actions.travelSearch.fetchAvailableArticles);
	const data = useStoreState((state) => state.travelSearch);

	useEffect(() => {
		if (data.items.length === 0) {
			fetchAvailableArticles();
		}
	}, [data.items, fetchAvailableArticles]);

	if (data.items.length === 0) {
		return <Loading />;
	} else {
		return (
			<>
				{data.items
					.sort((x, y) => x.article.sort - y.article.sort)
					.map((x) => (
						<ItemLine item={x} key={x.id} />
					))}
			</>
		);
	}
}

export default ItemsPicker;
